function search () {
  //搜索左侧搜索类型点击 下拉展开收起
  $(document).on('click', '.search_1', function () {
    $(this).find('.search_menu').toggle();
  })

  var url = "https://www.baidu.com/s?wd=", keyword = '';
  //搜索下拉项点击 切换搜索类型
  $(document).on('click', '.search_1 .search_menu a', function (ev) {
    ev.preventDefault();
    var tarType = $(this).attr('data-type');
    var oldType = $(this).parents('.search_1').find('a:first').attr('data-type');

    $(this).parents('.search_1').find('a:first').attr('data-type', tarType);
    $(this).parents('.search_1').find('a:first').attr('class', 'search_' + tarType);

    $(this).attr('data-type', oldType);
    $(this).attr('class', 'search_' + oldType);

    if (tarType == 'baidu') {
      url = "https://www.baidu.com/s?wd="

    } else if (tarType == 'sougou') {
      url = "https://www.sogou.com/web?query="
    } else if (tarType == '360') {
      url = "https://www.so.com/s?q="
    } else if (tarType == 'bing') {
      url = "https://cn.bing.com/search?q="
    } else if (tarType == 'zhongji') {
      // 站内搜索
      url = ""
    }
  })
  //搜索输入框 输入
  $(".s_inp").bind('input propertychange', function (e) {
    e.preventDefault();
    keyword = $(this).val() ? $(this).val().trim() : ''
  })

  //搜索点击 跳转 搜索
  $(document).on('click', '.s_btn', function (e) {
    e.preventDefault();
    if (url && keyword) {
      this.open(url + keyword, '_blank');
    }
  })
}
export {
  search
}  



// WEBPACK FOOTER //
// ./src/assets/js/search.js